export default class Volantino {
  constructor() {
    this.$select = $('.store-list-selector');
  }

  init() {
    this.handlerStore();
  }

  handlerStore() {
    this.$select.on('change', (e) => {
      const $selected = $(e.target.selectedOptions);
      const storeId = $selected.val();
      const url = $selected.attr('data-url');
      if (!url) return;
      $.spinner().start();
      $.ajax({
        url: url,
        type: 'GET',
        data: jQuery.param({ storeId: storeId }),
        success: (data) => {
          $.spinner().stop();
          $('.hero-content-volantino .flyer-iframe').attr('src', data.flyerUrl);
        },
        error: () => {
          $.spinner().stop();
        }
      });
    });
  }
}
